import plantillasFormModel from './plantillasFormModel';

const {
  formField: { name, message, category, business },
} = plantillasFormModel;

const initialValues = {
  [name.name]: '',
  [message.name]: '',
  [category.name]: '',
  [business.name]: '',
};

export default initialValues;
